import styled from 'styled-components';
import Input from '../Input';
import Button from '../Button';
import BackgroundImg from '../../assets/images/placeholder.png';

const TopMenu = styled.div`
    display: inline-block;
    width: 100%;
    @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[1]}) {
      display:block;
    };
  ul{
    background:#dfdfdf;
    margin:0px;
    padding:0px;
    li{
      display:inline-block;
      width:50%;
      text-align:center;
      &.location{
        float: Left;
        line-height: 10px;
        margin: 2px;
        margin-bottom:0px;
    

      .location-drop{
    width:100%;
    float:left;
    border-radius:0px;
    margin:0px;
    .Select.is-focused:not(.is-open) > .Select-control{
      background :url(${BackgroundImg}) transparent no-repeat 9px !important;
    }
    .Select-menu-outer{
      font-size:13px;
    }
    .Select-control{
      border-radius:0;
      background :url(${BackgroundImg}) transparent no-repeat 9px !important;
      .Select-value{
        padding-left:30px;
        font-size:13px;
      }
      .Select-input{
        padding-left:30px;
        font-size:13px;
      }
      .Select-clear{
        display:none;
      }
    }
  }

      }
      a{
        text-decoration:none;
        color:${(props) => props.theme.secondaryColor};
        font-weight:600;
        display:block;
        padding:15px 0px;
        border:${(props) => props.theme.lightGray} solid 1px;
      }
    }
  }
`;

const MainMenu = styled.div`
  background:${(props) => props.theme.whiteColor};
  padding:10px 0px;
  &.mb-none{
    display: none;
  }
  .backBtn{
    font-size: 30px;
    font-weight: bold;
    margin-left: 25px;
    width:22px;
    margin-top: 18px;
  }
  .mobile-search{
    background: #dfdfdf;
    padding: 10px 5px;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    z-index: 10;
    h1{
      margin:0px;
    }
    .Select{
      width:90%;
      margin-bottom:10px;
      .Select-control{
        border-radius:0px;
        height:40px;
        .Select-clear-zone{
          display:none;
        }
        .Select-placeholder{
          font-size: 12px;
    margin-top: 3px;
        }
      }
    }
    .close{
      position: absolute;
    right: 13px;
    top: 17px;
    /* background: #ff0000; */
    width: 20px;
    height: 20px;
    border-radius: 50%;
    text-align: center;
    color: ${(props) => props.theme.LandingBlack};
    cursor: pointer;
    }
    ${Input}{
      width: 82%;
    margin: 0px 0px 0px 0px;
    padding: 12px;
    background:${(props) => props.theme.whiteColor};
    }
    ${Button}{
      margin:0px;
      line-height:normal;
    }
  }
  .logo{
    text-align:center;
    .zaggle-logo{
      width: 100px;
      height: 30px;
      margin-top: 6px;
    }
    .manipal-logo{
      width: 100%;
    }
  }
  .left{
    header{
      margin-top: 6px;
    }
    .sr-only {
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip: rect(0,0,0,0);
      border: 0;
    }
    .menu-toggle {
      display: inline-block;
      padding: 0;
      line-height: 0;
      font-size: 30px;
      color:${(props) => props.theme.secondaryColor};
      cursor: pointer;
      margin-left: 14px;
      img{
        width:22px;
        margin-top: 4px;
        cursor: pointer;
      }
    }
    
    .menu-toggle:hover,
    #main-menu-checkbox:focus ~ header .menu-toggle {
      /* color: #c00;
      outline: auto; */
    }
    
    #main-menu-checkbox {
      position: absolute;
      left: -100vw; /* get it off the screen */
    }
    .main-menu {
      position: absolute;
      left: -300px;
      top: 0;
      height: 100%;
      overflow-y: scroll;
      overflow-x: visible;
      transition: left 0.3s ease,
                  box-shadow 0.3s ease;
      z-index: 999;
    }
    
    .main-menu ul {
      list-style: none;
      margin: 0;
      padding: 0;
      /* Hide shadow w/ -8px while 'closed' */
      -webkit-box-shadow: -8px 0 8px rgba(0,0,0,.5);
         -moz-box-shadow: -8px 0 8px rgba(0,0,0,.5);
              box-shadow: -8px 0 8px rgba(0,0,0,.5);
      min-height: 100%;
      width: 300px;
      background:${(props) => props.theme.whiteColor};
      li{
        .location-drop{
          .Select-control{
            .Select-clear-zone{
              display:none;
            }
          }
        }
        &.download{
          text-align: center;
          background: #eee;
          padding: 10px;
          margin-top:20px;
          a{
            display: inline-block;
            position: relative;
            width: 100%;
            span{
              img{
                width: 30px;
                position: absolute;
                left: 35px;
                top: 0;
              }
            }
          }
        }
       &.location{
        padding:5px 10px;
        border-bottom: 1px solid #eee;
        font-size:14px;
       }
        &.profile{
          float: left;
          width: 100%;
          a{
            display: inline-block;
            width: 100%;
            img{
              width: 50px;
              margin-right:0px;
              float:left;
              border-radius: 50%;
            }
            span{
              float: left;
              margin-top: 20PX;
              margin-left: 10px;
            }
            .fa{
              margin-top: 20PX;
              float:right;
            }
          }
          img{
            border-radius:50%;
          }
        }
        ul{
          box-shadow:none;
          li{
            a{
              padding-left:45px;
              font-weight: normal;
              border-bottom: 1px solid ${(props) => props.theme.lightWhite};
            }
          }
        }
      }
    }
    
    .main-menu a,
    .main-menu .a,
    .main-menu .menu-close {
      display: block;
      padding: 15px;
      line-height: 1em;
      font-size: 14px;
      color: ${(props) => props.theme.secondaryColor};
      font-weight:600;
      text-decoration: none;
      img{
        width:16px;
        margin-right:5px;
      }
      
      &.border{
        border-bottom: 1px solid #eee;
      }
      b{
        float:right;
        font-weight:700;
      }
    }
    
    .main-menu li:first-child a {
      border-top: 1px solid #eee;
    }
    
    .main-menu a:hover,
    .main-menu a:focus,
    .main-menu .menu-close:hover,
    #main-menu-checkbox:focus ~ header .menu-close {
      background: ${(props) => props.theme.webGray};
      text-decoration: none;
      border-radius: 50%;
    }
    
    .main-menu .menu-close {
      position: absolute;
      right: 0;
      top: 1.8rem;
      cursor: pointer;
    }
    
    #main-menu-checkbox:checked ~ header .main-menu,
    .main-menu[aria-expanded="true"] {
      left: 0;
      outline: none;
      -moz-box-shadow: 3px 0 12px rgba(0,0,0,.25);
      -webkit-box-shadow: 3px 0 12px rgba(0,0,0,.25);
      box-shadow: 3px 0 12px rgba(0,0,0,.25);
    }
    
    #main-menu-checkbox:checked ~ header .menu-close,
    .main-menu[aria-expanded="true"] .menu-close {
      z-index: 1001;
      border-bottom:0;
     /* display:none; */
    }
    
    #main-menu-checkbox:checked ~ header .main-menu ul,
    .main-menu[aria-expanded="true"] ul {
      position: relative;
      z-index: 1000;
    }
    
    #main-menu-checkbox:checked ~ header .backdrop,
    .main-menu[aria-expanded="true"] + .backdrop {
      position: absolute;
      display: block;  
      content: "";
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: 998;
      background: ${(props) => props.theme.blackColor};
      background: rgba(0,0,0,.85);
      cursor: default;
    }
    
    @supports (position: fixed) {
      .main-menu,
      #main-menu-checkbox:checked ~ header .backdrop,
      .main-menu[aria-expanded="true"] + .backdrop {
        position: fixed;
      }
    }
    
    @media (min-width: 769px) {
      .menu-toggle,
      .main-menu .menu-close,
      #main-menu-checkbox {
        display: none;
      }
    
      .main-menu {
        position: relative;
        left: auto;
        top: auto;
        height: auto;
      }
      
      .main-menu ul {
        display: flex;
        
        padding: 0;
        -webkit-box-shadow: none;
           -moz-box-shadow: none;
                box-shadow: none;
        height: auto;
        width: auto;
        background: none;
      }
      
      .main-menu a {
        color: #06c;
        border: 0 !important; 
      }
      
      .main-menu a:hover,
      .main-menu a:focus {
        background: none; 
        color: ${(props) => props.theme.primaryColor};
      }
    }
  }
  .right{
    text-align:right;
    font-size:28px;
    .cart{
      margin-right:20px;
      position:relative;
      img{
        width:22px;
        vertical-align: baseline;
      }
      b{
        font-size: 10px;
        position: absolute;
        background: ${(props) => props.theme.primaryColor};
        width: 20px;
        height: 20px;
        line-height: 20px;
        border-radius: 50%;
        color:${(props) => props.theme.whiteColor};
        text-align: center;
        right: -15px;
      }
    }
    .search{
      margin-right:15px;
      img{
        width:22px;
        vertical-align: baseline;
      }
    }
    .profile-img{
      img{
        width:20px;
        margin-right:10px;
        vertical-align: baseline;
      }
    }
  }
  .clr-black {
    color: ${(props) => props.theme.LandingBlack};
    font-weight: 600;
    padding: 10px 0px 10px 15px;
    &:hover{
      color: ${(props) => props.theme.primaryColor};
    }
    .corp-icon{
      width: 16px;
      height: 16px;
      object-fit: contain;
      margin-right: 5px;
      vertical-align: middle;
    }
  }
`;
const SeconderyMenu = styled.div`
  background:${(props) => props.theme.primaryColor};
  display:none;
  ul{
    margin:0px;
    padding:0px;
    li{
      display:inline-block;
      width:33%;
      text-align:center;
      a{
        text-decoration:none;
        color:${(props) => props.theme.whiteColor};
        font-weight:600;
        display:block;
        padding:5px 15px;
        font-size:14px;
      }
    }
    }
  }
`;

export { TopMenu, MainMenu, SeconderyMenu };



// WEBPACK FOOTER //
// client/components/MobileMenu/index.js